module.exports = __webpack_public_path__ + "static/media/CTLI_4-235w.9be90bb8.png";